<template>
  <v-container style="padding: 0; margin: 0">
    <v-layout wrap flex>
      <v-flex
        xs12>
        <Topo :empresa="empresa"/>
        <v-card
          v-show="exportando_dados"
          :max-height="heightCard"
          :style="(exportando_dados)?'overflow: auto; background-color: #E1E1E1':'overflow: auto;'"
          class="mb-3"
        >
          <v-layout
            v-if="exportando_dados"
            :style="{'height': heightCard}"
            column
            fill-height
            justify-center
            align-center
          >
            <img
              :style="{'height': '200px'}"
              src="assets/videos/brcorte_caw.gif" >
          <!--
                    <v-progress-circular
                    :size="50"
                    color="primary"
                    indeterminate
                  >
                  </v-progress-circular>-->
          </v-layout>
        </v-card>
        <v-container
          v-show="!exportando_dados"
          grid-list-md>
          <v-layout
            flex
            row
            wrap>
            <v-flex
              md2
              xs12
              class="v-chip-link">
              <v-chip
                color="secundary"
                dark
                small
                @click="go('/empresa/parceiros?acao=add-cliente')"
              >
                {{ strings[idioma].add_cliente }}
              </v-chip>
            </v-flex>
            <v-flex
              v-if="clientes.length > 0"
              id="colaboradores_area"
              xs12
              text-xs-center>
              <material-card
                :text="strings[idioma].clientes"
                :color="colorCard">
                <v-text-field
                  :label="strings[idioma].pesquisar"
                  v-model="searchClientes"
                  flat
                  hide-details
                  clearable
                  append-icon="mdi-magnify"
                  clear-icon="mdi-close"/>
                <v-divider/>
                <v-list
                  style="padding: 0; margin: 0; max-height: 250px; width: 100%; overflow:auto;"
                  dense
                  flat
                  rounded>
                  <v-list-tile
                    v-for="us in clientesFilter"
                    :key="us.id"
                    :style="us.plano.revogado === 1 || us.vencido ? 'color: red; font-weight: 900!important;': null"
                    flat
                    @click="openInfoVinculado(us)">
                    <v-list-tile-avatar>
                      <v-icon
                        v-if="us.EXCLUIDO !== 1"
                        :color="(us.permissao === 0) ? 'red': ''"
                        v-text="'mdi-account'"
                      />
                      <v-icon
                        v-else
                        :color="(us.permissao === 0) ? 'red': ''"
                        v-text="'mdi-account-off'"
                      />
                    </v-list-tile-avatar>
                    <v-list-tile-action style="min-width: 100px;">
                      <span>{{ us.id }} <br><small>P.Nº: {{ us.pedido }}</small></span>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      {{ us.NOME }} -
                      {{ us.plano.revogado === 1 ? '[' + strings[idioma].revogado + ']' : '' }}
                      {{ us.pecuarista ? strings[idioma].pecuarista : '' }}
                      {{ us.consultor ? strings[idioma].consultor : '' }}
                      {{ us.premiumStart ? strings[idioma].premium : '' }}
                      - {{ us.valido_ate ? us.valido_ate : '' }}
                      <v-list-tile-sub-title>{{ us.email }}</v-list-tile-sub-title>
                    </v-list-tile-content>

                  </v-list-tile>
                </v-list>
                <v-btn @click="exportaCSV">{{ strings[idioma].exporta_csv }}</v-btn>
              </material-card>
            </v-flex>
            <v-layout
              v-if="currUser && currUser !== null"
              wrap
              id="usr_area">
              <v-flex
                v-if="currUser !== null"
                id="colaboradores_area"
                lg6
                xs12
                text-xs-center>
                <material-card
                  :text="strings[idioma].usuario"
                  :color="colorCard">
                  <p>#{{ currUser.id }}</p>
                  <p>{{ currUser.NOME }}</p>
                  <p>{{ currUser.email }}</p>
                  <p v-if="currUser.phone">{{ '+'+currUser.phone.cod_pais + '('+currUser.phone.DDD+')'+currUser.phone.telefone }}</p>
                  <p v-if="currUser.endereco">{{ currUser.endereco.cidade + ' - '+currUser.endereco.estado+' - '+currUser.endereco.pais }}</p>
                  <p>Nº Pedido: {{ currUser.pedido }}</p>
                  <p>Valor: {{ currUser.valor ? currUser.valor : 'Não Declarado' }}</p>
                  <p>{{ currUser.premiumStart ? strings[idioma].premium : '' }}{{ currUser.pecuarista ? strings[idioma].pecuarista : '' }}{{ currUser.consultor ? strings[idioma].consultor : '' }}</p>
                  <p>{{ currUser.valido_ate ? currUser.valido_ate : '' }} {{ currUser.vencido ? '- VENCIDO' : '' }}</p>
                  <p>{{ currUser.plano.EXCLUIDO === 1 || currUser.plano.revogado === 1 ? 'Inativo' : 'Ativo' }}</p>

                  <v-btn
                    class="success"
                    @click="alterarSenha(currUser)">
                    {{ strings[idioma].mudar_senha }}
                  </v-btn>
                  <v-btn
                    class="primary"
                    @click="mudarPlano(currUser)">
                    {{ strings[idioma].mudar_plano }}
                  </v-btn>
                  <v-btn
                    class="warning"
                    @click="renovarPlano(currUser)">
                    {{ strings[idioma].renovar_plano }}
                  </v-btn>
                  <hr>
                  <p/>
                  <v-btn
                    class="error"
                    small
                    @click="desvincularEmpresa(currUser)">
                    {{ strings[idioma].desvincular_parceiro }}
                  </v-btn>
                  <v-btn
                    v-if="parseInt(currUser.plano.revogado) === 0"
                    class="error"
                    small
                    @click="revogarPlano(currUser)">
                    {{ strings[idioma].revogar_plano }}
                  </v-btn>
                  <v-btn
                    v-else
                    class="warning"
                    small
                    @click="ativarPlano(currUser)">
                    {{ strings[idioma].ativar_plano }}
                  </v-btn>

                </material-card>
              </v-flex>
              <v-flex
                v-if="dietasCarregadas"
                lg6
                xs12
                text-xs-center>
                <material-card
                  :text="strings[idioma].dietas_predicoes_salvas"
                  :color="colorCard">
                  <v-text-field
                    :label="strings[idioma].pesquisar"
                    v-model="searchDietas"
                    flat
                    hide-details
                    clearable
                    append-icon="mdi-magnify"
                    clear-icon="mdi-close"/>
                  <v-divider/>
                  <div style="padding: 0; margin: 0; max-height: 300px; width: 100%; overflow:auto;">

                    <v-card
                      style="padding: 0; margin: 0; width: 100%"
                      tile
                    >
                      <v-list
                        dense
                        flat
                        rounded>
                        <div color="primary">
                          <v-list-tile
                            v-for="dieta in dietasCarregadasFilter"
                            :key="dieta.id"
                            flat
                            color="primary"
                            @click="openDieta(dieta)">
                            <v-list-tile-avatar>
                              <v-icon

                                v-text="'mdi-folder'"
                              />
                            </v-list-tile-avatar>
                            <v-list-tile-content style="min-width: 70%">
                              <v-list-tile-title

                                class = "text-uppercase"
                              > {{ dieta.nome }} </v-list-tile-title>
                              <v-list-tile-sub-title>{{ moment(dieta.time).format(strings[idioma].formato_datas_com_hora) }}  <small style="font-size: 9px;">( {{ isNaN(dieta.animal.peso_corporal_inicial) ? dieta.animal.peso_corporal_medio : (parseFloat(dieta.animal.peso_corporal_final) + parseFloat(dieta.animal.peso_corporal_inicial)) / 2 }} Kg. - {{ dieta.animal.ganho_medio_diario }} Kg.- {{ strings[idioma][dieta.animal.tipo] }} )</small></v-list-tile-sub-title>
                            </v-list-tile-content>
                          </v-list-tile>
                        </div>
                      </v-list>

                    </v-card>
                  </div>
                </material-card>
              </v-flex>

            </v-layout>
          </v-layout>
        </v-container>
        <v-dialog
          v-model="alterarSenhaDialog"
          max-width="300">
          <v-card v-if="alterarSenhaDialog">
            <v-card-title>
              <v-layout column>
                <span class="headline">{{ strings[idioma].mudanca_senha }}</span>
                <span style="font-weight: 400;">{{ strings[idioma].coloque_senha_temporaria }}</span>
                <v-divider/>
              </v-layout>
            </v-card-title>
            <v-card style="overflow:auto; padding: 10px;">
              <v-card style="overflow:auto; padding: 10px;">
                <v-layout>
                  <v-text-field
                    v-model="senha"
                    :type="'password'"
                    focus/>
                </v-layout>
              </v-card>
            </v-card>
            <v-card-actions>
              <v-spacer/>
              <v-btn
                :title="strings[idioma].salvar"
                color="success"
                small
                @click="saveSenha()"
              >
                <v-icon
                  dark>mdi-content-save</v-icon>
              </v-btn>

              <v-btn
                :title="strings[idioma].fechar"
                color="error"
                small
                @click="descartarSenha()"
              >
                <v-icon
                  dark>mdi-close</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog
          v-model="dialogPremium"

          persistent
          transition="dialog-bottom-transition"
          width="650"
          height="300"
        >
          <v-card style="min-height: 100px;">
            <v-layout
              v-if="loading"
              fill-height
              align-center
              justify-center
              column
              style="padding: 20px;"
            >
              <v-progress-circular
                :size="50"
                color="primary"
                indeterminate
              />
            </v-layout>
            <template v-else-if="dialogPremium">
              <v-card-title>
                <v-layout column>
                  <template v-if="currUser && currUser !== null">
                    <span class="headline">{{ String(strings[idioma].definir_tempo_premium_para).format(currUser.NOME) }}</span>
                    <span v-if="currUser.plano"> {{ (currUser.plano) ? moment(currUser.plano.data_inicio).format(strings[idioma].formato_datas_sem_hora) : '' }} - {{ moment(currUser.plano.data_final).format(strings[idioma].formato_datas_sem_hora) }} </span>
                  </template>
                  <template v-else>
                    <span class="headline">{{ strings[idioma].tempo_premium }}</span>
                  </template>
                </v-layout>
              </v-card-title>
              <v-card>
                <v-list>
                  <v-list-tile
                    class="list-restricoes">
                    <v-radio-group
                      v-model="tipo"
                      v-bind="binding"
                      row
                      class="purple-input"
                    >

                      <v-flex>
                        <v-radio
                          :label="strings[idioma].pecuarista"
                          :value="0"/>
                      </v-flex>
                      <v-flex>
                        <v-radio
                          :label="strings[idioma].premium"
                          :value="1"/>
                      </v-flex>
                      <v-flex>
                        <v-radio
                          :label="strings[idioma].consultor"
                          :value="2"/>
                      </v-flex>
                    </v-radio-group>
                  </v-list-tile>
                  <template v-if="currUser === null">
                    <v-list-tile
                      class="list-restricoes">
                      <v-text-field
                        v-model="nome"
                        :label="strings[idioma].nome + '*'"/>
                    </v-list-tile>
                    <v-list-tile
                      class="list-restricoes">
                      <v-text-field
                        v-model="email"
                        :label="strings[idioma].email + '*'"/>
                    </v-list-tile>
                  </template>
                  <v-list-tile
                    class="list-restricoes">
                    <v-text-field
                      v-model="dataFim"
                      :label="strings[idioma].data_final + '*'"
                      type="date"/>
                  </v-list-tile>
                  <v-list-tile
                    class="list-restricoes">
                    <v-text-field
                      v-model="valorPlano"
                      :label="strings[idioma].valor_plano"
                      pattern="\d*"
                      inputmode="decimal"
                      type="float"/>
                  </v-list-tile>
                  <v-list-tile
                    class="list-restricoes">
                    <v-text-field
                      v-model="numeroPedido"
                      :label="strings[idioma].numero_do_pedido + '*'"/>
                  </v-list-tile>
                  <v-list-tile
                    v-if="tipo === 2"
                    class="list-restricoes">
                    <v-text-field
                      v-model="maxClientes"
                      :label="strings[idioma].maximo_clientes + '*'"
                      type="number"/>
                  </v-list-tile>
                </v-list>
              </v-card>
              <v-card-actions>
                <v-checkbox
                  v-if="currUser !== null"
                  v-model="novoPlano"
                  :label="strings[idioma].criar_novo_plano"/>
                <v-spacer/>
                <v-btn
                  color="success"
                  @click="currUser !== null ? salvarPremium(currUser, dataFim) : criarPremium(nome, email, dataFim, valorPlano, numeroPedido, maxClientes, tipo, novoPlano)">
                  <v-icon
                    left
                    dark>mdi-content-save</v-icon>
                  {{ strings[idioma].salvar }}
                </v-btn>
                <v-btn
                  :title="strings[idioma].fechar"
                  color="error"
                  @click="currUser !== null ? dialogPremium = false : go('/empresa/parceiros')"
                >
                  <v-icon
                    dark>mdi-close</v-icon>
                </v-btn>
              </v-card-actions>
            </template>
          </v-card>
        </v-dialog>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { mapState } from 'vuex'
import { getData, getDataEmpresa, updateData, getVinculados, getDietasNaoVinculados, getNaoVinculados, groupBy, createMD5, exportCSV } from '@/utils/utils'
import Topo from './Topo'
import moment from 'moment'
import VueExcelXlsx from 'vue-excel-xlsx/VueExcelXlsx'
import {
  CRESCIMENTO_TERMINACAO,
  VACA,
  NAO_GESTANTE
} from '@/utils/types.js'
import {
  replaceSpecialChars
} from '@/utils/vuex'
import { registerFont } from 'ol/render/canvas'
export default {
  components: {
    Topo
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    empresa: Object
  },
  data () {
    return {
      exportando_dados: false,
      currUser: null,
      empTecnicoVenda: null,
      dietasCarregadas: [],
      searchDietas: null,
      searchClientes: null,
      clientes: [],
      alterarSenhaDialog: false,
      dialogPremium: false,
      nome: '',
      email: '',
      dataFim: null,
      valorPlano: null,
      maxClientes: null,
      tipo: null,
      novoPlano: false,
      numeroPedido: null,
      senha: '',
      loading: false
    }
  },
  computed: {
    ...mapState('app', ['strings', 'idioma', 'user', 'ingredientes', 'optionsNumber', 'alimentos_selecionados', 'categorias_alimentos', 'alert', 'dietas', 'predicoes', 'tabelas', 'vinculados']),
    heightCard () {
      return String(this.$vuetify.breakpoint.height - 150) + 'px'
    },
    colorCard () {
      return 'indigo lighten-5'
    },
    CargosFilter () {
      return this.Cargos.filter(c => this.user.permissao === 0 || (c.nivel > this.user.emp_user.acesso || this.user.emp_user.acesso === 0))
    },
    Cargos () {
      let cargos = [{
        'nome': this.strings[this.idioma]['empresa_gestor'],
        'nivel': 0,
        'id': 'empresa_gestor'
      },
      {
        'nome': this.strings[this.idioma]['empresa_gerente_regional'],
        'nivel': 1,
        'id': 'empresa_gerente_regional'
      },
      {
        'nome': this.strings[this.idioma]['empresa_tecnico_venda'],
        'nivel': 2,
        'id': 'empresa_tecnico_venda'
      },
      {
        'nome': this.strings[this.idioma]['empresa_produtor_vinculado'],
        'nivel': 3,
        'id': 'empresa_produtor_vinculado'
      }
      ]
      return cargos
    },
    ehGestorOuAdmin () {
      return this.user.permissao === 0 || (this.user.emp_user && this.user.emp_user.acesso === 0)
    },
    ehGestor () {
      return (this.user.emp_user && this.user.emp_user.acesso === 0)
    },
    ehAdmin () {
      return this.user.permissao === 0
    },
    clientesFilter () {
      if (this.searchClientes === null || this.searchClientes.trim() === '') return this.clientes
      return this.clientes.filter(p => new RegExp(replaceSpecialChars(this.searchClientes.toLowerCase()), 'i').test(p.id + '-' + p.email + '-' + p.NOME) && p.nome !== null && String(p.NOME).trim() !== '' && !p.EXCLUIDO)
    },
    dietasCarregadasFilter () {
      if (this.searchDietas === null || this.searchDietas.trim() === '') return this.dietasCarregadas.filter(p => p.nome !== null && String(p.nome).trim() !== '' && !p.oculta)
      return this.dietasCarregadas.filter(p => new RegExp(replaceSpecialChars(this.searchDietas.toLowerCase()), 'i').test(p.nome ? p.nome : p.name) && p.nome !== null && String(p.nome).trim() !== '' && !p.oculta)
    }
  },
  watch: {
    currUser (val) {
      if (val) {
        this.tipo = val.plano.tipo !== null ? val.plano.tipo : 1
        this.email = val.email
        this.nome = val.NOME
        this.valorPlano = val.plano.valor
        this.dataFim = val.plano.data_final ? moment(val.plano.data_final).format('YYYY-MM-DD') : null
        this.maxClientes = val.consultoria && val.consultoria.max_clientes !== null ? val.consultoria.max_clientes : 10
        this.numeroPedido = val.plano.pedido !== null ? val.plano.pedido : null
      }
    }
  },
  created () {
    this.preload()
  },
  methods: {
    go (url) {
      window.location.href = url
    },
    preload () {
      // apenas parceiros podem ver esta pagina
      if ([0, '0', false, null].includes(this.empresa.parceiro)) return (() => window.location.href = '/empresa')()
      // -------------------------------
      this.exportando_dados = true
      this.axios.post('parceiros/getClients', { id_empresa: this.empresa.id }).then(r => {
        let res = r.data.data
        res.forEach(p => {
          p.NOME = p.NOME && p.NOME !== null ? p.NOME.toUpperCase() : ''
          p.email = p.email.toLowerCase()
          p.pecuarista = p.plano.tipo === 0
          p.premiumStart = p.plano.tipo === 1
          p.consultor = p.plano.tipo === 2
          p.pedido = p.plano.pedido
          p.valor = p.plano.valor !== null ? String(p.plano.valor).replace('.', this.strings[this.idioma].separador_float) : ''
          p.valido_ate = this.strings[this.idioma].valido_ate + ': ' + moment(p.plano.data_final).format(this.strings[this.idioma].formato_datas_sem_hora)
          p.vencido = moment(p.plano.data_final).isBefore(moment())
        })
        this.clientes = res
        this.exportando_dados = false
        if (this.$route.query.acao === 'add-cliente') {
          this.tipo = 0
          this.novoPlano = true
          this.dialogPremium = true
        }
      })
    },
    exportaCSV () {
      this.exportando_dados = true
      this.axios.post('parceiros/getClients', { id_empresa: this.empresa.id, csv: true }).then(r => {
        let dados = r.data.data
        exportCSV(dados)
      }).finally(_ => {
        this.exportando_dados = false
      })
    },
    validaDadosAssinatura (dados) {
      console.log({ dados })
      // o tipo deve ser valido
      if (dados.tipo === null || dados.tipo === undefined || dados.tipo === '' || !([0, 1, 2].includes(parseInt(dados.tipo)))) {
        alert(this.strings[this.idioma].selecione_tipo_plano)
        return false
      }
      // o nome deve ser valido
      if (dados.nome === null || dados.nome === undefined || dados.nome.trim() === '' || dados.nome.length < 3) {
        alert(this.strings[this.idioma].informe_nome_corretamente)
        return false
      }
      // o email deve ser valido
      if (dados.email === null || dados.email === undefined || dados.email.trim() === '' || !dados.email.includes('@')) {
        alert(this.strings[this.idioma].informe_email_corretamente)
        return false
      }
      // o numero de pedido deve ser valido
      if (dados.pedido === null || dados.pedido === undefined || dados.pedido.trim() === '' || dados.pedido.length < 4) {
        alert(this.strings[this.idioma].informe_pedido_corretamente)
        return false
      }
      // a data final deve ser valida
      if (dados.data_final) {
        if (dados.data_final === null || dados.data_final === undefined || dados.data_final.trim() === '' || !moment(dados.data_final).isValid()) {
          alert(this.strings[this.idioma].informe_data_final_corretamente)
          return false
        }
      } else {
        if (dados.dataFim === null || dados.dataFim === undefined || dados.dataFim.trim() === '' || !moment(dados.dataFim).isValid()) {
          alert(this.strings[this.idioma].informe_data_final_corretamente)
          return false
        }
      }
      

      return true
    },
    async criarPremium (nome, email, dataFim, valorPlano, numeroPedido, maxClientes, tipo, novoPlano) {
      this.loading = true
      let data = {
        nome: nome,
        email: email,
        data_final: dataFim,
        valor: valorPlano,
        pedido: numeroPedido,
        max_clientes: maxClientes,
        tipo: tipo,
        id_empresa: this.empresa.id,
        parceiro: this.empresa.id,
        novo_plano: novoPlano
      }
      let resultadoValidacao = this.validaDadosAssinatura(data)
      if (!resultadoValidacao) {
        this.loading = false
        return false
      }
      let res = await this.axios.post('parceiros/registerUserParceiro', data)
      if (res.data) {
        this.loading = false
        this.dialogPremium = false
        if (tipo === 2) await this.salvarConsultor(user, dataFim)
        if (res.data.senhaGerada) {
          alert("Senha Gerada: " + res.data.senhaGerada)
        }
        this.go('/empresa/parceiros')
      } else {
        this.loading = false
        this.dialogPremium = false
        alert(this.strings[this.idioma].erro)
      }
    },

    async salvarPremium (user, dataFim) {
      this.loading = true

      let resultadoValidacao = this.validaDadosAssinatura({ ...this, pedido: this.numeroPedido })
      if (!resultadoValidacao) {
        this.loading = false
        return false
      }
      let valor = this.valorPlano !== null ? String(this.valorPlano).replace(',', '.') : null
      if (moment().diff(dataFim) > 0) {
        let res = confirm(this.strings[this.idioma].msg_data_fim_premium_menor_atual)
        if (!res) {
          this.loading = false
          return
        }
      }
      if (this.currUser && this.currUser.consultoria !== null && this.tipo !== 2) {
        this.desativarConsultoria(user)
      }
      try {
        let res = await this.axios.post('users/setPremium',
          { id: user.id,
            premium: 1,
            data_final: dataFim,
            tipo: this.tipo,
            valor: valor,
            max_clientes: this.maxClientes,
            novo_plano: this.novoPlano,
            pedido: this.numeroPedido,
            id_empresa: this.empresa.id,
            EXCLUIDO: 0
          }
        )

        if (res.data) {
          this.loading = false
          this.dialogPremium = false
          if (this.tipo === 2) await this.salvarConsultor(user, dataFim)
          if (res.data.senhaGerada) {
            alert("Senha Gerada: " + res.data.senhaGerada)
          }
          window.location.href = '/empresa/parceiros'
        } else {
          this.loading = false
          alert(this.strings[this.idioma].erro_salvar_premium)
        }
      } catch (e) {
        this.loading = false
        this.dialogPremium = false
        alert(this.strings[this.idioma].erro_salvar_premium)
        
      }
    },
    salvarConsultor (user, dataFim) {
      this.loading = true
      return this.axios.post('consultoria/create', { id_pessoa: user.id, max_clientes: this.maxClientes, data_fim: dataFim, autorizado: true, id: user.consultoria ? user.consultoria.id : null, pedido: this.numeroPedido, id_empresa: this.empresa.id, EXCLUIDO: 0 }).then((res) => {
        this.preload()
        window.location.href = '/empresa/parceiros'
      }).catch(() => {
        alert(this.strings[this.idioma].aviso_erro_premium)
        this.loading = false
      })
    },
    touglePremium (us) {
      if (this.tempo_premium && this.tempo_premium === true) {
        this.dialogPremium = true
        delete this.premium
        delete this.tempo_premium
        return
      }
      /* this.dialogPremium = true
      delete this.premium */
      let user = Object.assign({}, us)
      user.premium = !user.premium
      if (user && user.consultoria !== null && !user.premium) {
        this.desativarConsultoria(user)
      }
      this.axios.post('users/setPremium', { id: user.id, premium: user.premium }).then((res) => {
        this.axios.post('users/get', { limit: this.limit, offset: this.limit * this.pagina }).then(r => { this.users = r.data.data.users; this.dialogPremium = false }).catch(() => window.location.href = '/adm')
      }).catch(() => {
        alert(this.strings[this.idioma].aviso_erro_premium)
        user.premium = !user.premium
      })
    },
    desativarConsultoria (user) {
      this.axios.post('consultoria/delete', { id: user.consultoria ? user.consultoria.id : null }).then((res) => {
        this.axios.post('users/get', { limit: this.limit, offset: this.limit * this.pagina }).then(r => { this.users = r.data.data.users; this.dialogConsultor = false }).catch(() => window.location.href = '/adm')
      }).catch(() => {
        alert(this.strings[this.idioma].aviso_erro_premium)
      })
    },
    tougleConsultor (us) {
      if (this.tempo_consultor && this.tempo_consultor === true) {
        this.dialogConsultor = true
        delete this.consultoria
        delete this.tempo_consultor
        return
      }
      if (this.consultoria) {
        this.axios.post('consultoria/delete', { id: us.consultoria ? us.consultoria.id : null }).then((res) => {
          this.axios.post('users/get', { limit: this.limit, offset: this.limit * this.pagina }).then(r => { this.users = r.data.data.users; this.dialogConsultor = false }).catch(() => window.location.href = '/adm')
        }).catch(() => {
          alert(this.strings[this.idioma].aviso_erro_premium)
        })
        return
      }
      /* this.dialogPremium = true
      delete this.premium */
      let user = Object.assign({}, us)
      user.premium = !user.premium
      this.axios.post('users/setPremium', { id: user.id, premium: user.premium }).then((res) => {
        this.axios.post('users/get', { limit: this.limit, offset: this.limit * this.pagina }).then(r => { this.users = r.data.data.users; this.dialogPremium = false }).catch(() => window.location.href = '/adm')
      }).catch(() => {
        alert(this.strings[this.idioma].aviso_erro_premium)
        user.premium = !user.premium
      })
    },
    openInfoVinculado (us) {
      // us.cargo = this.Cargos[us.emp_user.acesso].nome
      this.currUser = us
      this.axios.post('dieta/getDietasByUser', { id: us.id }).then(res => {
        this.dietasCarregadas = res.data.data.map(dieta => {
          let dietaDetalhada = JSON.parse(dieta.dieta)
          dietaDetalhada.id = dieta.id
          return dietaDetalhada
        })
        setTimeout(() => {
          let target = document.getElementById('usr_area')
          target.scrollIntoView({
            block: 'end',
            behavior: 'smooth'
          })
          let parent = document.getElementById('conteudo')
          parent.scrollTop = target.offsetTop - parent.offsetTop
        }, 30)
      })
      // this.dietasCarregadas = us.dietas.reverse().map(u => JSON.parse(u.dieta))
    },
    ativarPlano (user) {
      if (confirm(this.strings[this.idioma].ativar_plano_descricao)) {
        this.axios.post('parceiros/user/reativarPlano', { id: user.id, id_empresa: this.empresa.id }).then(response => {
          let msg = this.strings[this.idioma].ativado_sucesso
          let title = ''
          this.$store.commit('openOKModal', { title, msg })
          this.currUser = null
          this.preload()
        })
      }
    },
    alterarSenha (user) {
      if (confirm(this.strings[this.idioma].mudar_senha_descricao)) {
        this.alterarSenhaDialog = true
      }
    },
    saveSenha () {
      if (this.currUser === null) return
      if (this.senha.length <= 3) {
        this.loading = false
        let msg = 'Sua senha deve ter no mínimo 3 digitos.'
        let time = 6000
        this.$store.commit('openErrorAlert', { msg, time })
        return
      }
      this.axios.post('parceiros/user/mudaSenha', { id: this.currUser.id, id_empresa: this.empresa.id, senha: this.senha.trim() }).then(response => {
        let msg = this.strings[this.idioma].cadastrado
        let title = ''
        this.senha = ''
        this.alterarSenhaDialog = false
        this.$store.commit('openOKModal', { title, msg })
      })
    },
    descartarSenha () {
      this.senha = ''
      this.alterarSenhaDialog = false
    },
    desvincularEmpresa (user) {
      if (confirm(this.strings[this.idioma].desvincular_parceiro_descricao)) {
        this.axios.post('parceiros/user/desvincular', { id: user.id, id_empresa: this.empresa.id }).then(response => {
          let msg = this.strings[this.idioma].desvinculado_com_sucesso
          let title = ''
          this.$store.commit('openOKModal', { title, msg })
          this.currUser = null
          this.preload()
        })
      }
    },
    revogarPlano (user) {
      if (confirm(this.strings[this.idioma].revogar_plano_descricao)) {
        this.axios.post('parceiros/user/revogarPlano', { id: user.id, id_empresa: this.empresa.id }).then(response => {
          let msg = this.strings[this.idioma].revogado
          let title = ''
          this.$store.commit('openOKModal', { title, msg })
          this.currUser = null
          this.preload()
        })
      }
    },
    mudarPlano (user) {
      if (confirm(this.strings[this.idioma].mudar_plano_descricao)) {
        this.dataFim = moment(this.currUser.plano.data_final).format('YYYY-MM-DD')
        this.novoPlano = true
        this.dialogPremium = true
      }
    },
    renovarPlano (user) {
      if (confirm(this.strings[this.idioma].renovar_plano_descricao)) {
        this.dataFim = (this.currUser.vencido) ? moment().add(1, 'Y').format('YYYY-MM-DD') : moment(this.currUser.plano.data_final).add(1, 'Y').format('YYYY-MM-DD')
        this.novoPlano = true
        this.dialogPremium = true
      }
    },
    desvincula (user) {
      let empresa = this.empresa
      let usuario = user
      let cargo = user.cargo
      console.log(this.Cargos.filter(c => cargo === c.nome)[0], cargo)
      let acesso = this.Cargos.filter(c => cargo === c.nome)[0].nivel
      if (confirm(this.strings[this.idioma].voce_tem_certeza_disso)) {
        this.axios.post('empresa/desvincula', {
          id_empresa: empresa.id,
          id_pessoa: usuario.id,
          acesso: acesso
        }).then(response => {
          let msg = this.strings[this.idioma].desvinculado_com_sucesso
          let title = ''
          this.$store.commit('openOKModal', {
            title,
            msg
          })
          getVinculados(this.$store.state, this.empresa.id, this.axios)
          this.currUser = null
          this.dietasCarregadas = null
        })
      }
    },
    atualizaVinculo (user) {
      let empresa = this.empresa
      let usuario = user
      let cargo = user.cargo
      let acesso = this.Cargos.filter(c => cargo === c.nome)[0].nivel
      this.axios.post('empresa/vincula', {
        id_empresa: empresa.id,
        id_pessoa: usuario.id,
        acesso: acesso
      }).then(response => {
        let msg = this.strings[this.idioma].vinculo_atualizado
        let title = ''
        this.$store.commit('openOKModal', {
          title,
          msg
        })
        this.preload()
        this.getData()
        getVinculados(this.$store.state, this.empresa.id, this.axios)
        this.currUser = null
        this.dietasCarregadas = null
      })
    },
    moment (...args) {
      return moment(...args)
    },
    openDieta (dieta) {
      if (dieta.tipo_alimento_predicao && (dieta.tipo_alimento_predicao === 'MS' || dieta.tipo_alimento_predicao === 'MN')) {
        this.openPredicao(dieta)
      } else {
        this.$store.commit('loadDieta', dieta.name)
        setTimeout(() => {
          this.$router.push('/formulacao-dieta?did=' + dieta.id + '&assinatura=' + createMD5(String(dieta.id)))
        }, 300)
      }
    },
    openPredicao (dieta) {
      this.$store.commit('loadPredicao', dieta.name)
      setTimeout(() => {
        this.$router.push('/predicao-desempenho?did=' + dieta.id + '&assinatura=' + createMD5(String(dieta.id)))
      }, 300)
    }
  }
}

</script>
